import { useUserRoles } from 'src/features/auth/useUserRoles';

export function useCanLaunchMerchantApplication() {
  const { isBambi, isOwner } = useUserRoles();

  return isBambi || isOwner;
}
